import { hot } from "react-hot-loader";

import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "../../../../shared/utilities/graphql/apolloClient";
import SaveButton from "./SaveButton";

const ConnectedSaveButton = props => (
  <ApolloProvider client={apolloClient}>
    <SaveButton {...props} />
  </ApolloProvider>
);

export default hot(module)(ConnectedSaveButton);
